import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class OperationalShowAllCertificateGridService {

    constructor() { }

    fileNameCellRenderer(rowData) {
        return rowData.unreadNotification ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup"></i></span>` : '';
    }   

    savingsCellRenderer(rowData, field) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    };

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData, field) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return !Number.isNaN(value) ? `<div class="text-truncate" title="` + value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '';
        }

    }

    cols: Array<TableColumn> = [
        {
            field: '',
            header: 'Checkbox',
            pinned: true,
            columnCheckBox: true            
        },
        {
            field: 'unit',
            header: 'Unit Number',
            translationKey: 'UnitNumber',
            sort: true,
            pinned: true,
            sortName: 'unit',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'fileName',
            header: 'Certificate Name',
            translationKey: 'CertificateName',
            sort: true,            
            sortName: 'fileName',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onFileNameClick',
                renderEventBeforeHtml: this.fileNameCellRenderer
            }
        },
        {
            field: 'createdOn',
            header: 'Created Date',
            translationKey: 'CreatedDate',
            sort: true,            
            sortName: 'createdOn',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
              type: CellRendererTypes.html,
              renderHtml: this.dateCellRenderer
        }
        },
        {
            field: 'fileSize',
            header: 'File Size(MB)',
            translationKey: 'FileSize',
            sort: true,
            sortName: 'fileSize',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        }        
    ];
}
